<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Donation</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/lps/report/view/vendor">Report</router-link> /
      <b>Donations</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
            <!-- <router-link to="/payout/update" type="button" class="btn btn-primary mb-2 pull-right">Upload</router-link> -->
        </div>

        <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
            <span class="m-auto"></span>
        </div>
    </div>


    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <img :src='banner'> -->
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
              
            <div id="active" class="">
                <div class='row'>
                  <div class="col-12 col-lg-6 col-sm-12">
                    <h4 class="card-title mb-3">
                      <b>Donation Report for : {{ charity.name }}</b>
                    </h4>
                    <p>The table shows the donation report.</p>
                  </div>

                  <div class="col-12 col-lg-6 col-sm-12 align-items-center">
                    <h4 class="card-title mb-3 text-right">
                      Total Price Redeemed: <strong>$ {{total_money}}</strong> <br>
                      Total Points Redeemed: <strong>{{total_points}} TBM Points</strong>
                      
                    </h4>
                  </div>
                </div>

                <!-- For filters -->
                <div class="row">
                  <!-- Month -->
                  <div class="col-6">
                    <div class="form-group">
                      <label>Month</label>
                      <select class="form-control" v-model="filter_month">
                        <option v-for="(month, index) in months" :key="index" :value="month.value">{{month.name}}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Year -->
                  <div class="col-6">
                    <div class="form-group">
                      <label>Year</label>
                      <select class="form-control" v-model="filter_year">
                        <option v-for="(year, index) in years" :key="index">{{year}}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Redeemed By -->
                  <div class="col-6">
                    <div class="form-group">
                      <label>Donated By</label>
                      <select class="form-control" v-model="filter_redeemed_by">
                        <option  v-for="(redeemed_by, index) in redeemed_bys" :key="index" :value="redeemed_by.id">{{redeemed_by.name}}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Submit filter -->
                  <div class="col-6">
                    <div class="form-group">
                      <button class="btn btn-primary" @click="loadCharity(true)">Filter</button> &nbsp;
                      <button class="btn btn-primary" @click="removeFilter()">All</button>
                    </div>
                  </div>
                </div>


                <!-- Active -->
                <div class="table-responsive">
                    <table  id="charity_table"  class="display table table-striped table-bordered"  style="width:100%; text-align: center;">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Username</th>
                                <th>Points Donated</th>
                                <th>($) Donated</th>
                                <th>Donated At</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            <tr v-for="(donation, index) in donations" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ donation.user.name }}</td>
                                <td>{{ donation.points }}</td>
                                <td>{{ donation.price }}</td>
                                <td>{{ donation.donated_at }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


    <script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "donation-report",
  components: {},

  data() {
    return {
      donations : [],
      charity: null,
      success: true,
      total_money: 0,
      total_points: 0,
      banner: "",
      redeemed_bys: [],
      months: [
        {"name":"January", "value" : 1}, 
        {"name":"February", "value" : 2}, 
        {"name":"March", "value" : 3}, 
        {"name":"April", "value" : 4}, 
        {"name":"May", "value" : 5}, 
        {"name":"June", "value" : 6}, 
        {"name":"July", "value" : 7}, 
        {"name":"August", "value" : 8}, 
        {"name":"September", "value" : 9}, 
        {"name":"October", "value" : 10}, 
        {"name":"November", "value" : 11}, 
        {"name":"December", "value" : 12}
      ],
      years: [],
      filter_month: null,
      filter_year: null,
      filter_redeemed_by: null,
    };
  },

  methods: {
    loadYearFilter(){
      let date = new Date()
      let start_date = 2020
      let current_year = date.getFullYear()

      // Past 5 year
      for(let i = start_date; i < current_year + 1; i++){
        this.years.push(i)
      }
    },
    loadCharity(filter = false) {
      this.destroyDatatable();
      let token = localStorage.getItem("token");
      let url = axios.lpsURL + `/donation?charity_id=${this.$route.params.id}`;

      if (filter) {
        url += `&month=${this.filter_month}&year=${this.filter_year}`
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;


        axios
          .get(url, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            const { success, charity, donations, total_money, total_points, redeemed_bys } = res.data;
            this.success      = success;
            this.charity      = charity;
            this.donations    = donations;
            this.total_money  = total_money;
            this.total_points = total_points;
            this.redeemed_bys = redeemed_bys;
            // this.banner       = axios.lpsURL + "/" + this.charity.banner
            

          })
          .then(function() {
            $("#charity_table").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    removeFilter(){
      this.filter_month = null
      this.filter_year = null
      this.filter_redeemed_by = null
      this.years = []
      this.loadData()
    },

    loadData() {
      this.loadCharity();
      this.loadYearFilter();
    },

    destroyDatatable() {
      $("#charity_table").DataTable().destroy();
    },

  },

  mounted() {
    this.loadData();
  }
};
</script>
